export const WebsiteTourConstant = {
    ACTIVATE : 'ACTIVATE',
    DEACTIVATE : 'DEACTIVATE',
    ACTIVATE_FOR_SCAN : 'ACTIVATE_FOR_SCAN',
    DEACTIVATE_FOR_SCAN : 'DEACTIVATE_FOR_SCAN',
}